import React from 'react';
import LegalDocument from './LegalDocument';
import { SUPPORT_EMAIL } from '../config/emailjs';

const INTRO =
  'Estas condiciones aplican cuando usás Contsuite (contsuite.com.ar). Al registrarte confirmás que las leíste y que vas a usar la plataforma de forma responsable.';

const SECTIONS = [
  {
    id: 'servicio',
    heading: '1. Servicio',
    paragraphs: [
      'Contsuite es una plataforma web para registrar ventas, gastos, clientes y cobranzas, con reportes orientados a la gestión del negocio y herramientas para compartir información con un contador.',
    ],
    bullets: [
      'Registro interno de movimientos y cartera de clientes.',
      'Priorización de cobranzas, recordatorios y pack exportable para el estudio contable.',
      'No emitimos comprobantes electrónicos ante ARCA ni liquidamos impuestos.',
    ],
  },
  {
    id: 'cuenta',
    heading: '2. Cuenta y uso',
    paragraphs: ['Para operar tu cuenta:'],
    bullets: [
      'Mantené tu contraseña en secreto y usá un email al que tengas acceso.',
      'Los datos que cargás deben ser veraces y correspondan a tu negocio.',
      'Está prohibido usar el servicio para actividades ilegales, acceder a cuentas ajenas o intentar dañar la plataforma.',
    ],
  },
  {
    id: 'planes',
    heading: '3. Planes y pagos',
    paragraphs: [
      'Algunas funciones dependen del plan contratado (Básico, Profesional o Empresarial). Precios y límites vigentes están en la sección Planes.',
      'Los pagos recurrentes se procesan mediante Mercado Pago u otro medio que indiquemos. Podés cancelar la renovación desde Cuenta → Suscripción o desde Mercado Pago.',
      'Cancelación voluntaria: dejás de renovar automáticamente, pero conservás el acceso hasta el fin del período ya abonado (o hasta el fin del período de prueba si aún no hubo cobro). No hay reembolso ni crédito proporcional por días no usados.',
      'No ofrecemos pausa gratuita del plan: solo renovación activa o baja al vencer el período. Para volver a usar Contsuite después deberás contratar un plan nuevamente (nuevo checkout en Mercado Pago).',
      'Solo el titular de la cuenta puede gestionar la suscripción; los usuarios invitados de una empresa no pueden cancelar el plan del negocio.',
      'Si un cobro falla, Contsuite aplica 15 días de gracia con acceso de solo lectura (ver y exportar datos). Pasado ese plazo se suspende el acceso a la app sin borrar tu información de inmediato; retenemos los datos hasta 12 meses con aviso previo por email antes de una eventual baja de cuenta. Al regularizar el pago recuperás el acceso completo.',
    ],
  },
  {
    id: 'propiedad',
    heading: '4. Propiedad intelectual',
    paragraphs: [
      'El software, diseño, marca y documentación de Contsuite son propiedad del titular del servicio. No adquirís derechos sobre el código ni sobre la marca por usar la plataforma.',
      'Vos conservás la titularidad de los datos de tu negocio que cargás (clientes, movimientos, notas). Podés exportarlos según las funciones de tu plan.',
    ],
  },
  {
    id: 'responsabilidad',
    heading: '5. Limitación de responsabilidad',
    paragraphs: [
      'Contsuite se ofrece “tal cual”. No garantizamos resultados comerciales, cobros efectivos ni exactitud impositiva. Para presentaciones formales o criterio fiscal, consultá a tu contador.',
      'En la medida permitida por la ley aplicable, no respondemos por lucro cesante, pérdida de datos por causas fuera de nuestro control razonable, ni daños indirectos derivados del uso o imposibilidad de uso del servicio.',
    ],
  },
  {
    id: 'contacto',
    heading: '6. Contacto',
    paragraphs: [
      `Consultas sobre estos términos: ${SUPPORT_EMAIL}. Podemos actualizar este documento; la fecha de revisión figura arriba. El uso continuado después de un cambio relevante implica que aceptás la versión publicada.`,
    ],
  },
];

export default function Terminos() {
  return (
    <LegalDocument
      variant="terms"
      title="Términos de uso"
      updated="octubre 2026"
      intro={INTRO}
      sections={SECTIONS}
    />
  );
}
